import { useState, useEffect, useRef } from 'react'
import { Link, useNavigate, useLocation } from "react-router-dom"
import styles from './ExtraBadgeTemplateStyling.module.css'
import { useReactToPrint } from 'react-to-print'

// ------ Components ------ //
import LoadingSpinner from '../../../components/Miscellaneous/LoadingSpinner'
import ExtraBadgeTemplate from '../../../components/Badging/ExtraBadgeTemplateStyling/ExtraBadgeTemplate'

// ------ Services ------ //
import * as badgeService from '../../../services/badgeManagementService'
import * as clientEventService from '../../../services/clientEventService'
import * as kioskService from '../../../services/kioskService'

// ------ React Tabs ------ //
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

const ExtraBadgeTemplateStyling = () => {

    // Make form of CSS properties (font size, style, margin, etc)
    // Create a CSS object in state with default or null CSS values for all these properties
    // Have the form overwrite this object
    // Have a UI copy of this object below the form (for developer purposes) that will directly update that object in state

    // State
    const [extraBadgeTemplate, setExtraBadgeTemplate] = useState([])
    const [clientEventInfo, setClientEventInfo] = useState({})
    //const [printAreaDimensions, setPrintAreaDimensions] = useState("4x4")
    const [loaded, setLoaded] = useState(false)
    const [clientEventRequestBody, setClientEventRequestBody] = useState({})
    //const [saveConfirmationVisible, setSaveConfirmationVisible] = useState(false)

    // Tabs state/constants
    const [tabIndex, setTabIndex] = useState(0)
    const tabLabels = [
        "Event Setup",
        "Event Badges Setup",
        "Guest Badges Setup",
        "Extra Badges Setup",
        "Kiosk Setup"
    ]

    // Constants
    const navigate = useNavigate()
    const location = useLocation()
    const passedState = location.state
    const clientEventInfoRef = useRef(null)

    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            clientEventInfoRef.current = passedData
        }
    }

    const createRequestBody = async () => {
        let requestBody = {}
        if (clientEventInfo.clientId && clientEventInfo.eventId) {
            requestBody =
            {
                "clientId": `${clientEventInfo.clientId}`,
                "eventId": `${clientEventInfo.eventId}`
            }
        }
        setClientEventRequestBody(requestBody)
        return await requestBody;
    }

    // React-to-Print
    const componentRef = useRef()
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "Badge Styling - Print Preview",
        removeAfterPrint: true,

        /*onAfterPrint: () => alert("Print Success")*/
    })


    // Refactored useEffect for Setting Styling Form Data
    useEffect(() => {
    

        const fetchData = async () => {
            try {
                const getReqBody = await createRequestBody();
                const extraBadgeTemplate = await badgeService.getExtraBadgeTemplates(getReqBody)
                
                //console.log("extraBadgesTemplates: ", extraBadgeTemplate)
                if (extraBadgeTemplate) {
                    setExtraBadgeTemplate(extraBadgeTemplate)
                }
               
                setLoaded(true)

/*                await initializeStylingData(getReqBody, badgeFields, templates[0]);*/
            } catch (error) {
                console.error("Error fetching EventBadgeFields JSON: ", error);
/*                resetStylingState();*/
                setLoaded(true);
            }
        };

        if (clientEventInfo?.clientId !== undefined && clientEventInfo.clientName) {
            fetchData();
        }
    }, [clientEventInfo]);

    useEffect(() => {
        // store into local object
        if (!passedState || !passedState.clientName) {
            if (clientEventInfoRef.current) {
                setClientEventInfo(clientEventInfoRef.current)
            }
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            setClientEventInfo(passedData)
            clientEventInfoRef.current = passedData;
        }
    }, [])

    useEffect(() => {
        // reflects client/event selection changes made in Header.jsx without polling
        const handleClientEventChange = (e) => {
            // Update clientevent with every render when its value has changed.
            let savedClientEvent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current && clientEventInfoRef.current.eventId !== undefined &&
                savedClientEvent && savedClientEvent.eventId !== undefined &&
                savedClientEvent.eventId !== clientEventInfoRef.current.eventId) {
                setClientEventInfo(savedClientEvent)
                clientEventInfoRef.current = savedClientEvent;
            }
        }
        window.addEventListener('clientEventChange', handleClientEventChange)
        return () => window.removeEventListener('clientEventChange', handleClientEventChange)
    }, [])

    return (
        <div className={loaded ? styles.printPage : ""}>
            {
                loaded ?
                    <>
                        {extraBadgeTemplate && extraBadgeTemplate.length > 0 ? 
                            <>
                                <h1>Template Styling - Extra Badge</h1>
                                <br /> <br />
                                <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
                                <br />

                                <Tabs
                                    selectedIndex={tabIndex}
                                    onSelect={(index) => setTabIndex(index)}
                                    id={styles.tabsSection}
                                >
                                    <TabList id={styles.tabsList}>
                                        {extraBadgeTemplate.map((ebt, index) => (
                                            <Tab key={index} className={index === tabIndex ? styles.selected : styles.tabs}>
                                                {ebt.templateName}
                                            </Tab>
                                        ))}
                                    </TabList>

                                    {extraBadgeTemplate.map((ebt, index) => (
                                        <TabPanel>
                                            <ExtraBadgeTemplate
                                                ebt={ebt}
                                                key={index}
                                                styles={styles}
                                                clientEventRequestBody={clientEventRequestBody}
                                            /*compileForms={compileForms}*/
                                            /*badgeDimensions={badgeDimensions}*/
                                            /*setBadgeDimensions={setBadgeDimensions}*/
                                            /*handleDimensionChange={handleDimensionChange}*/
                                            /*handleBadgeDimensionChange={handleBadgeDimensionChange}*/
                                            /*saveConfirmationVisible={saveConfirmationVisible}*/
                                            /*setSaveConfirmationVisible={setSaveConfirmationVisible}*/
                                            />
                                        </TabPanel>
                                    ))}
                                </Tabs>     
                                <br /> <br />
                                <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
                                <br />
                            </>
                            : <>
                                <div> No Extra badges Configured</div>
                                <br />
                                <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
                                <br />
                                <Link to="/BadgeToERSPropertyMapping"
                                    className={styles.eventLinks}
                                    state={clientEventInfo}
                                >
                                    <h3>Go to Mapping Page</h3>
                                </Link>
                            </>
                        }
                                          
                    </>
                    :
                    <LoadingSpinner />
            }
        </div>
    );
}

export default ExtraBadgeTemplateStyling